import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { EstadoCaso, OrigenCaso } from '../../../api/altasCasosApi';
import { ESTADO_COLORS, ESTADO_LABELS, ORIGEN_COLORS, ORIGEN_LABELS } from './estado';

export const EstadoCasoTag: React.FC<{ estado: EstadoCaso }> = ({ estado }) => (
  <Tag color={ESTADO_COLORS[estado]}>{ESTADO_LABELS[estado]}</Tag>
);

export const OrigenTag: React.FC<{ origen: OrigenCaso }> = ({ origen }) => (
  <Tag color={ORIGEN_COLORS[origen]}>{ORIGEN_LABELS[origen]}</Tag>
);

/**
 * Indicador ✓/✗ de verificación de email (D22) — solo aplica a origen web con email.
 * `verificado === null/undefined` = aún no consultado (stub/T01): no se muestra nada
 * para no afirmar un estado que no se conoce.
 */
export const EmailVerificadoBadge: React.FC<{ verificado?: boolean | null; aplica: boolean }> = ({
  verificado,
  aplica,
}) => {
  if (!aplica || verificado === null || verificado === undefined) return null;
  return verificado ? (
    <Tooltip title="Email verificado (estado que mantiene la web)">
      <CheckCircleTwoTone twoToneColor="#52c41a" />
    </Tooltip>
  ) : (
    <Tooltip title="Email no verificado (estado que mantiene la web)">
      <CloseCircleTwoTone twoToneColor="#ff4d4f" />
    </Tooltip>
  );
};
